<template>
  <section class="datatable__container">
    <transition name="fade" mode="out-in">
      <dr-loader v-if="!loaded"  class="flex-center" />

      <template v-if="getRows.length > 0">
        <datatable
          class="datatable__table"
          ref="datatable"
          :columns="columns"
          :page="currentPage"
          :per-page="1000"
          :filter-by="filterBy"
          :data.sync="getRows"
          :buttons="['copy', 'csv', 'excel', 'pdf', 'print']"
        >
          <template slot-scope="{ row }">
            <tr class="datatable__row">
              <td
                class="datatable__cell"
                v-for="(rowVal,rowName, $index) in orderRow(row)"
                v-show="rowName !== 'key' && !getProp(columns, rowName, 'hide')"
                :key="'row' + $index"
                :class="getProp(columns, rowName, 'class') + ' ' + ( 'text-' + getProp(columns, rowName, 'align')) || ''"
              >
                <div
                  v-if="!getProp(columns, rowName, 'action')"
                  :class="rowName + ' ' + row.type.toLowerCase() + ' ' + (rowName === 'status' ? rowVal.toLowerCase() : '')"
                  v-html="getFilter(rowName, rowVal)"
                >
                </div>

                <div v-else class="actions">
                  <template v-if="row.category !== 'Consulta Dr. Conecta'">
                    <a @click="$emit('edit', row.id)">
                      <dr-icon color="#a8b7c7" name="edit" />
                    </a>

                    &nbsp;

                    <a @click="deleteRow(row.id)" class="d-inline-block">
                      <dr-icon :color="'#e57066'" :name="'excluiAlerta'" />
                    </a>
                  </template>
                </div>
              </td>
            </tr>
          </template>
        </datatable>
      </template>

      <h2 v-if="loaded && getRows.length === 0" class="datatable__no-data">
        Não há dados.
      </h2>
    </transition>
    <!-- <footer class="pagination flex-middle flex-end" >
      <datatable-pager :ref="'datatablePager'" v-if="loaded" type="abbreviated" class="wrapper pagination" v-show="getRows.length > getPerPage" v-model="currentPage" ></datatable-pager>
    </footer> -->
  </section>
</template>
<style scoped>
  a.material-icons:hover {
    color: white !important
  }
</style>

<script>
import { mapGetters } from 'vuex'

export default {
  props: [ 'columns', 'rows', 'page', 'perPage', 'filterBy', 'row', 'rowData', 'expand', 'selectedOffice' ],
  components: {
  },
  data () {
    return {
      localRows: [],
      localRowData: [],
      updateTable: false,
      currentPage: 1,
      getTransition: 'fade',
      getTransition2: 'slide-down',
      loaded: false,
      expanded: null,
      loaded2: false
    }
  },
  mounted () {
    this.getRows = this.rows
    if (this.rows.length > 0) {
      this.loaded = true
    }
  },
  computed: {
    ...mapGetters({
      office: 'getCurrentOffice'
    }),

    getRoute () {
      return this.$route.name
    },
    getPerPage () {
      return this.perPage || 10
    },
    getPage () {
      return this.currentPage
    },
    getCustomer () {
      return this.$store.getters.getParentObj.customerId
    },
    getRowData: {
      get () {
        return this.localRowData
      },
      set (v) {
        this.localRowData = v
      }
    },
    getRows: {
      get () {
        return this.localRows
      },
      set (rows) {
        let key = 0
        this.localRows = []
        for (let row of rows) {
          if (this.fn_IS_OBJ(row)) {
            this.localRows.push(row)
            this.localRows[key].key = key
            key++
          }
        }
        this.loaded = true
      }
    }
  },
  watch: {
    'rows': function (next, prev) {
      this.loaded = false
      this.getRows = next
      this.loaded = true
    },
    rowData (next, prev) {
      const self = this
      self.getRowData = next
      setTimeout(() => {
        self.loaded2 = true
      }, 1500)
    },
    'currentPage': function (next, prev) {
      if (next > prev) {
        this.getTransition = 'fade_left'
      } else {
        this.getTransition = 'fade_right'
      }
    }
  },
  methods: {
    expandRow (id, y, m) {
      const self = this
      self.loaded2 = false
      setTimeout(function () {
        self.getRowData = []
        if (self.expanded !== id) {
          self.$refs.datatable.$parent.$parent.$emit('expand', [y, m])
          self.expanded = id
        } else {
          self.expanded = null
        }
      }, 400)
    },
    getFilter (rowName, rowValue) {
      if (this.getProp(this.columns, rowName, 'filter')) {
        const returned = this.$root.$options.filters[this.getProp(this.columns, rowName, 'filter')](rowValue)
        return Array.isArray(returned) ? `${returned[0]}<strong>${returned[1]}</strong>` : returned
      } else {
        return rowValue
      }
    },
    orderRow (row) {
      let obj = {}
      let key = 0
      for (let col of this.columns) {
        obj[col.field] = row[col.field]
        if (this.rowData) {
          obj.key = key++
        }
      }
      return obj
    },
    changePage (v) {
      if ((v < 0 && this.currentPage === 1) || (v > 0 && this.currentPage === Math.floor(this.getRows / this.perPage))) {
        return
      }
      this.currentPage = this.currentPage + v
    },
    updateRows () {
      this.getRows = null
    },
    mutateForm (id) {
      let updateObj = {}
      updateObj.activeId = id
      updateObj['active' + this.customerForm] = this.customerForm + 'Form'
      this.$store.dispatch('reloadDatatables')
      this.$store.dispatch('updateParentObj', updateObj)
    },
    mutateList (id) {
      let updateObj = {}
      updateObj.eventId = id
      updateObj.activeTab = 'stocks'
      this.$store.dispatch('updateParentObj', updateObj)
    },
    deleteRow (id) {
      console.log(this)
      const self = this
      this.$store.dispatch('setModalConfirm', {
        title: 'Confirmação',
        body: `Tem certeza que deseja remover o lançamento?`,
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        beforeClose (v) {
          if (!v) {
            this.$store.dispatch('setModalConfirm')
          } else {
            this.fn_SHOW_PROGRESS()
            this.$http.delete(`/doctor/doctor_office/${self.office.id}/financial_statement/${id}`, self.$store.getters.getAuthHeader).then(
              (res) => {
                self.$emit('refresh', true)
                this.$store.dispatch('setModalConfirm')
                this.$store.dispatch('setModalAlert', {
                  title: 'Sucesso',
                  body: 'Lançamento removido com sucesso',
                  size: 'md',
                  active: true
                })
                self.fn_HIDE_PROGRESS()
              }
            ).catch(
              (err) => {
                console.log(err)
              }
            )
          }
        },
        size: 'md',
        active: true
      })
    },
    checkInt (cols, field) {
      for (let col of cols) {
        if (col.field === field) {
          return col.intType
        }
      }
    },
    getProp (cols, field, prop) {
      for (let col of cols) {
        if (col.field === field) {
          return col[prop]
        }
      }
    }
  }
}
</script>
